/**
 * Estado local (por navegador) de la checklist de primeros pasos: lo que la API no registra
 * (si ya descargaste o imprimiste el QR) y si la ocultaste.
 */
const qrKey = (localId: string) => `gl:qr-downloaded:${localId}`;
const dismissKey = (localId: string) => `gl:first-steps-dismissed:${localId}`;

function read(key: string): boolean {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function write(key: string): void {
  try {
    localStorage.setItem(key, '1');
  } catch {
    // modo privado / storage bloqueado: la checklist simplemente no lo recuerda
  }
}

export const isQrDownloaded = (localId: string) => read(qrKey(localId));
export const markQrDownloaded = (localId: string) => write(qrKey(localId));
export const isFirstStepsDismissed = (localId: string) => read(dismissKey(localId));
export const dismissFirstSteps = (localId: string) => write(dismissKey(localId));
